import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { bridgeBackgroundOptions } from "../../src/bridge_background_options"

export default class extends BridgeComponent {
    static component = "profile"

    connect() {
        super.connect()

        const profilePictureUrl = this.element.dataset.profilePictureUrl
        this.profilePath = this.element.dataset.profilePath || "/profile/details"

        if (profilePictureUrl) {
            // Enable the profile button in the native app
            this.send("connect", { profilePictureUrl, ...bridgeBackgroundOptions(this.element) }, (message) => {
                if (message.data.profile !== undefined) {
                    this.handleProfileRequest()
                }
            })
        }
    }

    handleProfileRequest() {
        window.Turbo.visit(this.profilePath)
    }
}
